import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { Col } from '@thd-olt-component-react/core-ui';

import './totalPricing.scss';

export const Savings = ({
  value,
  percentage,
  mapExistsInPackage,
  title,
  label,
  isBundleSaving,
  isTotalSaving
}) => {

  const savings = percentage ? `$${value} (${percentage}%)` :
    `$${value}`;
  const formattedSavings = !isTotalSaving ? `-${savings}` : savings;
  const testId = title.replace(/ /g, '-');

  const textContainerClasses = classNames(
    'savings-container',
    {
      'u__text--success': isTotalSaving,
      'savings-container-label': label
    }
  );

  return value &&
    (
      <div data-testid={testId}>
        <Col className={textContainerClasses}>
          {title && <span className="total-savings__title">{title}</span>}
          <div className="savings-container">
            <span className="total-savings__value u__text--success">
              {(mapExistsInPackage && !isBundleSaving) ? '---' : formattedSavings}
            </span>
          </div>
        </Col>
        {label && (
          <div className="total-savings__label u__text--success">{label}</div>
        )}
      </div>
    );
};

Savings.propTypes = {
  value: string,
  label: string,
  percentage: string,
  mapExistsInPackage: bool,
  title: string,
  isBundleSaving: bool,
  isTotalSaving: bool
};

Savings.defaultProps = {
  value: null,
  percentage: null,
  mapExistsInPackage: false,
  title: '',
  label: '',
  isBundleSaving: false,
  isTotalSaving: false
};

Savings.displayName = 'Savings';